import { ThemeOptions } from '@mui/material/styles'
import '@fontsource/lato'

export const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: '#00818D',
    },
    secondary: {
      main: '#BC556C',
    },
    background: {
      default: '#f0f0f0',
    },
  },
  typography: {
    fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
  },
}
